export const PKG_NAME = "@hpcc-js/preact-shim";
export const PKG_VERSION = "2.19.3";
export const BUILD_VERSION = "2.108.11";
